import { Component, OnInit, Output, EventEmitter}
from "@angular/core";
import { Router, ActivatedRoute }       from "@angular/router";
import { Organisation, OrganisationWorkflow, AccountRole }
from "../../../models";
import { CurrentUserService, UserAuthenticationService }
from "../../../services/shared";
import { NgProgressService }                  from "ng2-progressbar";
import { USERHOMECONSTANTS }                from "../../../modules/userHome";
import { WORKFLOWCONSTANTS }                from "../workflow.constants";
import { OrganisationWorkflowService }           from "./organisationWorkflow.service";
const _ = require("underscore");
const swal = require("sweetalert2");

@Component({
    selector: "organisationWorkflow-component",
    template: require("./organisationWorkflow.component.html"),
    styles: [require("./organisationWorkflow.component.less").toString()],
    providers: [OrganisationWorkflowService]
})

export class OrganisationWorkflowComponent implements OnInit {
    @Output() handleProcessing: EventEmitter<any> = new EventEmitter();
    @Output() handleRejectProcessing: EventEmitter<any> = new EventEmitter();
    organisation = new Organisation();
    organisationWorkflow: OrganisationWorkflow;
    workflowTaskId: string;
    errorMessage: string;
    errors: Error[];
    loggedIn: boolean = false;
    isProcessing: boolean;
    isRejectProcessing: boolean;
    hasEditPermission: boolean;
    roleCode: string;
    roles: AccountRole[];

    constructor(private currentUserService: CurrentUserService,
        private userAuthService: UserAuthenticationService,
        private cecRouter: Router,
        private cecActivatedRoute: ActivatedRoute,
        private pService: NgProgressService,
        private organisationWorkflowService: OrganisationWorkflowService) {
    }

    /// #region - event handlers

    ngOnInit() {
        if (!this.userAuthService.isAuthenticated) {
            this.cecRouter.navigate(["/login"]);
            return;
        }
        // Apply security rules
        // Global admins, diocesan admin and organisation admin can edit contact details 
        this.hasEditPermission = this.currentUserService.IsGlobalAdmin() ||
                                this.currentUserService.IsDiocesanAdmin() ||
                                this.currentUserService.IsOrgAdmin();

        if (!this.hasEditPermission) {
            let mess = new Error();
            mess.message = USERHOMECONSTANTS.messages.requestUnauthorised;
            this.errors.push(mess);
            return;
        }
        // Start processing
        this.pService.start();
        this.organisationWorkflow = new OrganisationWorkflow();
        this.workflowTaskId = this.cecActivatedRoute.snapshot.params[WORKFLOWCONSTANTS.params.taskId];
        if (this.workflowTaskId) {
            this.organisationWorkflow.taskId = this.workflowTaskId;
            this.getAccountWorkflowByTaskId(this.workflowTaskId);
        }

        this.GetRoles();

        this.pService.done();
    }

    private GetWorkflowTaskMessage(){
        this.organisationWorkflowService
        .GetWorkflowTaskMessage(this.workflowTaskId)
        .subscribe(
        (response: OrganisationWorkflow) => {
            swal({
                title: "Task completed",
                text: response.comment,
                type: "warning",
                showCancelButton: false
            });
            this.onGoBack();
        },
        (error) => {
            let parsedErrors = JSON.parse(error._body);
            if (parsedErrors) {
                this.errorMessage = parsedErrors.message;
            }
            this.onGoBack();
        });
        
    }

    private GetRoles(): void {
        this.organisationWorkflowService
            .GetRoles()
            .subscribe(
            (response: AccountRole[]) => {
                this.roles = response;
            },
            (error) => {
                let parsedErrors = JSON.parse(error._body);
                if (parsedErrors) {
                    this.errorMessage = parsedErrors.message;
                }
            });
    }

    onAccountApprove() {
        this.errorMessage = "";
        this.errors = [];
        this.submitApproveRequest(this);
    }

    onAccountReject() {
        this.errorMessage = "";
        this.errors = [];
        this.submitRejectRequest(this);
    }

    onGoBack() {
        this.goBackToTasks();
    }

    onHandleProcessing(isProcessing) {
        this.isProcessing = isProcessing;
    }

    onHandleRejectProcessing(isRejectProcessing) {
        this.isRejectProcessing = isRejectProcessing;
    }

    goBackToTasks(): void {
        let tabId = this.cecActivatedRoute.snapshot.queryParams[USERHOMECONSTANTS.params.tabId];
        if (!tabId) {
            tabId = USERHOMECONSTANTS.tabIds.tasksId;
        }
        let navigationExtras = {
            queryParams: { "tabId": tabId }
        };
        this.cecRouter.navigate(["/myhome"], navigationExtras);
    }

    submitApproveRequest(accountWorkflowComponent: OrganisationWorkflowComponent) {
        swal({
            title: "Are you sure?",
            text: "You want to approve this account.",
            type: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes",
            cancelButtonText: "No"
        }).then(function () {
            accountWorkflowComponent.processApproveRequest();
        }, function (dismiss) {
        });
    }

    processApproveRequest() {
        this.pService.start();
        this.errorMessage = "";
        this.isProcessing = true;
        this.handleProcessing.emit(true);
        this.organisationWorkflow.organisationStatusCode = USERHOMECONSTANTS.accountStatus.active;
        if (this.roleCode !== this.organisationWorkflow.roleCode) {
            this.organisationWorkflow.roleCode = this.roleCode;
        }

        this.organisationWorkflowService
            .submitWorkflow(this.organisationWorkflow)
            .subscribe(
            (response: boolean) => {
                if (response === true) {
                    swal(
                        "Done!",
                        USERHOMECONSTANTS.messages.requestSuccessfull,
                        "success"
                    );
                } else {
                    swal(
                        "Failed!",
                        USERHOMECONSTANTS.messages.requestFailed,
                        "error"
                    );
                }
                this.goBackToTasks();
            },
            (error) => {
                let parsedErrors = JSON.parse(error._body);
                this.errorMessage = USERHOMECONSTANTS.messages.requestFailed;
                if (parsedErrors) {
                    parsedErrors.message = this.errorMessage;
                    let popupMessage = USERHOMECONSTANTS.messages.requestUnauthorised;
                    this.errors = parsedErrors.errors;
                    if (this.errors) {
                        popupMessage = this.errors[0].message;
                    }
                    swal(
                        parsedErrors.message,
                        popupMessage,
                        "error"
                    );
                }
            })
            .add(t => {
                this.isProcessing = false;
                this.handleProcessing.emit(false);
                this.pService.done();
            });
    }

    submitRejectRequest(accountWorkflowComponent: OrganisationWorkflowComponent) {
        swal({
            title: "<h3>Reason for rejecting</h3>",
            text: accountWorkflowComponent.organisationWorkflow.comment,
            type: "warning",
            input: "text",
            showCancelButton: true,
            confirmButtonText: "Submit",
            showLoaderOnConfirm: true,
            animation: "slide-from-top",
            inputPlaceholder: "Comment on rejection",
            preConfirm: function (inputValue) {
                return new Promise(function (resolve, reject) {
                    if (!inputValue) {
                        reject("Your comment is required!");
                    } else {
                        resolve();
                    }
                });
            },
            allowOutsideClick: false
        }).then(function (inputValue) {
            accountWorkflowComponent.organisationWorkflow.comment = inputValue;
            accountWorkflowComponent.processRejectRequest();
        }, function (dismiss) {
        });
    }

    processRejectRequest() {
        this.pService.start();
        this.errorMessage = "";
        this.isRejectProcessing = true;
        this.handleRejectProcessing.emit(true);
        this.organisationWorkflow.organisationStatusCode = USERHOMECONSTANTS.organisationStatus.inActive;
        this.organisationWorkflowService
            .submitWorkflow(this.organisationWorkflow)
            .subscribe(
            (response: boolean) => {
                if (response === true) {
                    swal(
                        "Done!",
                        USERHOMECONSTANTS.messages.requestSuccessfull,
                        "success"
                    );
                } else {
                    swal(
                        "Failed!",
                        USERHOMECONSTANTS.messages.requestFailed,
                        "error"
                    );
                }
                this.goBackToTasks();
            },
            (error) => {
                let parsedErrors = JSON.parse(error._body);
                this.errorMessage = USERHOMECONSTANTS.messages.requestFailed;
                if (parsedErrors) {
                    parsedErrors.message = this.errorMessage;
                    let popupMessage = USERHOMECONSTANTS.messages.requestUnauthorised;
                    this.errors = parsedErrors.errors;
                    if (this.errors) {
                        popupMessage = this.errors[0].message;
                    }
                    swal(
                        parsedErrors.message,
                        popupMessage,
                        "error"
                    );
                }
            })
            .add(t => {
                this.isRejectProcessing = false;
                this.handleRejectProcessing.emit(false);
            });
            this.pService.done();
    }

    getAccountWorkflowByTaskId(taskId: string): void {
        this.organisationWorkflowService
            .getWorkflowByTaskId(taskId, USERHOMECONSTANTS.taskTypeCodes.addedOrganisation)
            .subscribe(
            (response: OrganisationWorkflow[]) => {
                if (response) {
                    this.organisationWorkflow.extOrganisationId = response[0].extOrganisationId;
                    this.organisationWorkflow.userId = response[0].userId;
                    this.organisationWorkflowService
                        .getOrganisation(response[0].userId, taskId)
                        .subscribe(
                        (organisationResponse: Organisation) => {
                            this.organisation = organisationResponse[0]; 
                            if(this.organisation.accountId === "00000000-0000-0000-0000-000000000000"){
                                this.GetWorkflowTaskMessage();
                            }

                            this.roleCode = this.organisation.roleCode;
                        },
                        (accountError) => {
                            let parsedErrors = JSON.parse(accountError._body);
                            this.errorMessage = "Unable to retrieve workflow details. Please try later...";
                            if (parsedErrors) {
                                this.errors = parsedErrors.errors;
                            }
                        })
                } else {
                    this.errorMessage = "Unable to retrieve workflow details. Please try later...";
                }
            },
            (error) => {
                let parsedErrors = JSON.parse(error._body);
                this.errorMessage = "Unable to retrieve workflow details. Please try later...";
                if (parsedErrors) {
                    this.errors = parsedErrors.errors;
                }
            });
    }

    /// #endregion - functions    
}


// WEBPACK FOOTER //
// ./src/app/modules/workflow/organisation/organisationWorkflow.component.ts